module.exports = __webpack_public_path__ + "static/media/04.ccd738c3.png";